<template>

  <v-btn icon>

    <v-badge :color="model === null ? 'transparent' : 'green' " floating location="bottom right">
      <v-icon :icon="icon" />
    </v-badge>

    <v-tooltip v-if="hint" activator="parent" location="bottom" :text="hint" />

    <v-menu activator="parent" location="bottom right">

      <v-list density="compact">

        <v-list-item
          v-if="clearable"
          :title="$t('titles.all')"
          @click="model = null"
        >
          <template v-slot:prepend>
            <v-list-item-action start>
              <v-radio :model-value="!model" />
            </v-list-item-action>
          </template>
        </v-list-item>

        <v-list-item v-for="item in items" :key="item.value" :title="item.title" @click="model = item.value">
          <template v-slot:prepend>
            <v-list-item-action start>
              <v-radio :model-value="model === item.value" />
            </v-list-item-action>
          </template>
        </v-list-item>

      </v-list>

    </v-menu>

  </v-btn>

</template>

<script setup lang="ts">

interface Props {
  icon?: string
  hint?: string
  items: {value: any, title: string}[]
  clearable?: boolean
}

withDefaults(defineProps<Props>(), {
  icon: '$filter',
  clearable: true,
})

const model = defineModel<any>({default: null})

</script>
